import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ProductsPage } from '@/features/products/pages/ProductsPage'

const searchSchema = z.object({
  tab: z.enum(['categories', 'products', 'sellables', 'brands']).catch('categories'),
})

export const Route = createFileRoute('/_app/products/')({
  validateSearch: searchSchema,
  component: ProductsPage,
})
